{
  "appName": "Mi9 Nexus",
  "nexusAdmin": "Nexus Admin",
  "nav.overview": "Overview",
  "nav.dataPipeline": "Data Pipeline",
  "nav.mappings": "Mappings",
  "nav.deadLetterQueue": "Dead Letter Queue",
  "nav.selectRetailer": "Select retailer",
  "actions.save": "Save",
  "actions.cancel": "Cancel",
  "actions.close": "Close",
  "actions.delete": "Delete",
  "actions.back": "Back",
  "actions.done": "Done",
  "actions.remove": "Remove",
  "actions.tryAgain": "Try again",
  "actions.goBack": "Go back",
  "actions.goToSummary": "Go to summary",
  "actions.signOut": "Sign out",
  "actions.importMore": "Import More",
  "status.loading": "Loading...",
  "status.loadingEnvironments": "Loading environments...",
  "status.noEnvironments": "No environments available",
  "status.active": "Active",
  "status.inactive": "Inactive",
  "status.error": "Error",
  "status.warning": "Warning",
  "status.valid": "Valid",
  "status.live": "Live",
  "status.connecting": "Connecting",
  "status.offline": "Offline",
  "status.reconnecting": "Reconnecting",
  "empty.noData": "No data available",
  "empty.noResults": "No results found",
  "empty.noItems": "No items",
  "pagination.rowsPerPage": "Rows per page:",
  "pagination.showing": "Showing <1>{{start}}</1> to <2>{{end}}</2> of <3>{{total}}</3> items",
  "pagination.goToFirstPage": "Go to first page",
  "pagination.goToPreviousPage": "Go to previous page",
  "pagination.goToNextPage": "Go to next page",
  "pagination.goToLastPage": "Go to last page",
  "pagination.page": "Page {{page}}",
  "pagination.selectRowsPerPage": "Select number of rows per page",
  "aria.closeSidebar": "Close navigation menu",
  "aria.openSidebar": "Open navigation menu",
  "aria.closeSidebarOverlay": "Close sidebar overlay",
  "aria.mainNavigation": "Main navigation",
  "aria.primaryNavigation": "Primary navigation",
  "aria.mainContent": "Main content",
  "aria.paginationNavigation": "Pagination navigation",
  "aria.breadcrumb": "Breadcrumb",
  "aria.notifications": "Notifications",
  "aria.dismissNotification": "Dismiss {{title}} notification",
  "aria.selectRetailerEnvironment": "Select retailer and environment",
  "aria.clearSearch": "Clear search",
  "aria.userMenu": "User menu",
  "aria.settings": "Settings",
  "skipToMainContent": "Skip to main content",
  "skipToNavigation": "Skip to navigation",
  "topbar.settings": "Settings",
  "topbar.nonProd": "Non-Production Environment",
  "topbar.viewChangeHistory": "View change history",
  "changeHistory.title": "Change History",
  "changeHistory.empty": "No changelog is available for this build.",
  "theme.label": "Theme",
  "theme.light": "Light",
  "theme.dark": "Dark",
  "theme.system": "System",
  "user.defaultName": "User",
  "error.somethingWentWrong": "Something went wrong",
  "error.unexpectedError": "An unexpected error occurred in the application.",
  "error.unexpectedRetry": "An unexpected error occurred. Please try again.",
  "error.showDetails": "Show details",
  "error.hideDetails": "Hide details",
  "error.reportIssue": "Report this issue",
  "error.pageNotFound": "Page not found",
  "error.pageNotFoundMessage": "The page you are looking for does not exist or has been moved.",
  "error.accessDenied": "Access denied",
  "error.accessDeniedMessage": "You do not have permission to access this page.",
  "error.defaultError": "Error",
  "error.unknownError": "Unknown error",
  "shortcuts.title": "Keyboard Shortcuts",
  "shortcuts.description": "Use these keyboard shortcuts to navigate and perform actions quickly.",
  "shortcuts.toggleHint": "to toggle this dialog",
  "shortcuts.scope.global": "Global",
  "shortcuts.scope.editor": "Editor",
  "shortcuts.scope.navigation": "Navigation",
  "environmentSelector.selectContext": "Select context...",
  "environmentSelector.search": "Search...",
  "systemAlert.multipleIssues": "Multiple issues detected",
  "systemAlert.singleIssue": "A service requires attention",
  "systemAlert.stopped": "Stopped",
  "systemAlert.notActive": "Not Active",
  "systemAlert.unreachable": "Unreachable",
  "resultCount.showing": "Showing {{count}} of {{total}} {{label}}",
  "fileUpload.dragDrop": "Drag & drop a file here",
  "fileUpload.dropHere": "Drop file here",
  "fileUpload.orBrowse": "or click to browse",
  "fileUpload.supportedFormats": "Supported format: JSON (max {{maxSize}}MB)",
  "fileUpload.invalidType": "Invalid file type. Allowed types: {{accept}}",
  "fileUpload.tooLarge": "File too large. Maximum size: {{maxSize}}MB",
  "help.title": "Help",
  "help.relatedTopics": "Related Topics",
  "help.searchResults": "Search Results",
  "help.relevantToThisPage": "Relevant to This Page",
  "help.contextSpecific": "Context-specific help",
  "help.searchPlaceholder": "Search help topics...",
  "help.noResults": "No results found for \"{{query}}\"",
  "help.clearSearch": "Clear search",
  "help.toggleHint": "Press <1>F1</1> or <2>Ctrl+/</2> to toggle this panel",
  "help.resultsCount": "{{count}} results",
  "aria.helpPanel": "Help panel",
  "aria.closeHelpPanel": "Close help panel",
  "aria.backToTopicList": "Back to topic list",
  "aria.searchHelpTopics": "Search help topics",
  "aria.helpTopics": "Help topics"
}
